<template>
	<div id="top-nav-container" :class="{toggle:selected == 1}">

	    <header class="top-nav" :class="{ dimm:position[1] > 85, undimm:position[1] < 85, menuVisible: burgerHide == false }" id="toScroll">
            <div id="header-frst" class ="logo-transitioned logov1">
                <a class="rm-po-logo" href="https://www.richardmille.com/pre-owned"><img class="rm-po-logo" alt="Ninety - Richard Mille Official Pre-Owned Retailer" src="../assets/CPOtm-Logo-white.svg"></a>
                <router-link to="/">
                    <img class="logowjandloc" alt="Ninety - Richard Mille Official Pre-Owned Retailer" src="../assets/Logo-Thick-Gold.svg">
                    <img class="wjandloc" alt="Ninety - Richard Mille Official Pre-Owned Retailer" src="../assets/watches_jewlleryLG.svg">
                    <img class="Logo post-wjandloc"  alt="Ninety - Richard Mille Official Pre-Owned Retailer" src="../assets/Logo-9T-Thick-Gold.svg">
                    <img class="ninet-logo-mobile"  alt="Ninety - Richard Mille Official Pre-Owned Retailer" src="../assets/Logo-9T-Thick-Black.svg">
                    <img class="fulllogowjandloc" alt="Ninety - Richard Mille Official Pre-Owned Retailer" src="../assets/Logo-Thick-Black-watches_jewllery-L-G-UAEfull.svg">
                </router-link>
            </div>

            <div id="header-scnd" class="icon" style="grid-template: inherit;">
                <!-- <div class="whatsapp icon"><a class="contact-whatsapp whatsapp" v-if="londonboutique.WhatsAppNumber" :href="'https://wa.me/'+ londonboutique.WhatsAppNumber"><img class="center" src="/images/icons/whatsapp-grey.svg"></a> </div> -->
                <a v-if="londonboutique.WhatsAppNumber" :href="'https://wa.me/'+ londonboutique.WhatsAppNumber"><img class="center" src="/images/icons/whatsapp-grey.svg"></a>
                <!-- <router-link v-if="!authUser" to="/membership"><img class="center" src="/images/icons/Member.svg"></router-link>
                <router-link v-else to="/dashboard"><img class="center"  src="/images/icons/Member.svg"></router-link> -->
                 <div id="scroll-to-subscribe" v-scroll-to="'#subscribe'"><img style="height: 26px; margin-top: 8px; margin-left: 8px; position: relative; cursor: pointer;" class="center" src="/images/icons/subscribe-grey.svg"></div>
            </div>
            
            <div id="header-thrd">
                    <!-- Main navigation -->
                <div id="top-menu">
                    <nav class="navigation">
                        <div v-bind:class="burgerHide ? 'burger-hide' : 'burger-show'" @click="toggleBurgerClass()" class="menu-icon" ref="burgerBtn" id="menu-btn">
                            <span class="navicon"></span>
                        </div>
                        <!-- <div class="overlay-image" :style="{ backgroundImage: `url(${backgroundImage})` }" style="display: inline; width: 100px; height: 100px; position: absolute; left: -500px;"></div> -->
                        <div class="overlay-image" :style="{ backgroundImage: `url(${backgroundImage})` }"></div>
                        <div class="menu">
                            <article class="grid-container columns-two overlay-mask manu-v1">
                                <section class="section1">
                                    <div>
                                        <h2>Collection</h2>
                                        <ul>
                                            <li v-for="item in sortedCollectionsItems" :key="item.id">
                                                <router-link @click="toggleBurgerClass()" :to="item.router_link">{{ item.website_item }}</router-link>
                                            </li>
                                        </ul>
                                    </div>    
                                        <!-- <video autoplay loop muted>
                                            <source src="videos/Watch7.mp4" type="video/mp4" />
                                        </video> -->
                                </section>
                                <section class="section2">
                                    
                                        <!-- <video autoplay loop muted>
                                            <source src="videos/Watch4.mp4" type="video/mp4" />
                                        </video> -->
                                        <div>
                                        <h2>Discover</h2>
                                        <ul>
                                            <li v-for="item in sortedNinetyItems" :key="item.id">
                                                <router-link @click="toggleBurgerClass()" :to="item.router_link">{{ item.website_item }}</router-link>
                                            </li>
                                        </ul>
                                    </div>
                                </section>
                            </article>      
                        </div>   
                    </nav>
                </div>  
            </div>
            <!-- <div id="header-frth" class="icon">
                <router-link><img class="center" src="/images/icons/loupe.svg"></router-link>
            </div> -->
	    </header>
	</div>
</template>

<script>
import windowScrollPosition from '../mixins/WindowScrollPosition.js'
import ContactForm from './ContactForm.vue';
import { mapGetters } from "vuex";
import { mapState } from 'vuex'
export default {
    name: 'Header',
    props: ['boutique'],
    components: {
        ContactForm,
    },
    data() {
        return {
            status: [],
            showLogoLGD: true,
            selected: undefined,
            window: {
                width: 0
            },
            position: [],
            burgerHide: true,
            showRoute: this.$route.meta.title,
            backgroundImage:  '',
        }
    },

    mixins: [windowScrollPosition('position')],

    created() {
        window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },

    mounted() {
        this.getWebsiteItems();
        // window.addEventListener('scroll', this.handleScroll);
         if (!this.londonboutique || !this.londonboutique.PhoneNumber) {
      this.$store.dispatch('boutiques/fetchLondon') 
    if (!this.siteSettings || !Object.keys(this.siteSettings).length) {
      this.$store.dispatch('boutiques/fetchSiteSettings')
      }
    }
    },
        
    methods: {
        getWebsiteItems(address) {
              this.$axios.get(address ? address : "/api/websiteitems" ).then(response => {
               this.status = response.data.data;
             });
           },
        handleResize() {
            this.window.width = window.innerWidth;
        },
    
        toggleBurgerClass: function(event){
            this.burgerHide = !this.burgerHide;
        },
    },

    computed: {
        ...mapGetters("auth", ["authUser"]),
        sortedNinetyItems() {
            return this.status.filter(item => item.status === 0 && item.header_menu_section === 'Ninety')
            .sort((a, b) => b.display_order - a.display_order); // Reverse the order of comparison
        },
        sortedCollectionsItems() {
            return this.status.filter(item => item.status === 0 && item.header_menu_section === 'Collections')
                .sort((a, b) => b.display_order - a.display_order); // Reverse the order of comparison
        },
         ...mapState('boutiques', ['londonboutique', 'siteSettings']), // pull from Vuex
        currentRouteName() {
        return this.$route.name
        },
    },
    watch: {
        '$route.meta.title'() {
            this.showRoute = this.$route.meta.title;
        },

        $route (to, from){
            const burger = document.getElementById('menu-btn')
            if (burger.classList.contains('burger-show')) {
                this.burgerHide = !this.burgerHide;
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
}
</script>
